import { render, staticRenderFns } from "./Fujin.vue?vue&type=template&id=68218aa2&scoped=true&"
import script from "./Fujin.vue?vue&type=script&lang=js&"
export * from "./Fujin.vue?vue&type=script&lang=js&"
import style0 from "./Fujin.vue?vue&type=style&index=0&id=68218aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68218aa2",
  null
  
)

export default component.exports